


















import Vue from 'vue';
import { firebase } from 'mostra';
// import * as firebase from '@/plugins/firebase';

export type DataType = {
  admin: {
    uid: string;
    admin: boolean;
  };
};

export default Vue.extend({
  name: 'admin-text-rule',
  data(): DataType {
    return {
      admin: {
        uid: '',
        admin: true,
      },
    };
  },
  methods: {
    async onClickAdmin() {
      try {
        this.$loading(true);
        await firebase
          .functions('setCustomTokenAdmin', {
            uid: this.admin.uid,
            admin: this.admin.admin,
          });
        this.$success('保存しました。');
      } catch (error: any) {
        this.$error('保存に失敗しました。', error);
      } finally {
        this.$loading(false);
      }
    },
  },
  // async mounted() {
  // },
});
